<template>
    <div class="ui-page">
        <ui-page-header title="Perfis de acesso"
            subtitle="O que cada perfil pode ver, criar, editar e excluir em cada área do backoffice. A API confere o mesmo perfil.">
            <v-btn color="primary" depressed to="/perfis/novo"><v-icon left small>mdi-plus</v-icon>Novo perfil</v-btn>
        </ui-page-header>

        <ui-table-card>
            <v-data-table :headers="headers" :items="profiles" :loading="loading" disable-sort hide-default-footer :items-per-page="-1"
                no-data-text="Nenhum perfil cadastrado" loading-text="Carregando..." class="ui-clickable-rows" @click:row="open">
                <template v-slot:[`item.name`]="{ item }">
                    <div class="ui-cell-main">{{ item.name }}</div>
                    <div v-if="item.description" class="ui-cell-sub">{{ item.description }}</div>
                </template>
                <template v-slot:[`item.access`]="{ item }">
                    <ui-badge v-if="item.is_super" status="approved" text="acesso total" />
                    <span v-else class="ui-small">{{ summary(item) }}</span>
                </template>
                <template v-slot:[`item.admins`]="{ item }">
                    <span :class="{ 'ui-muted': !item.admins }">{{ item.admins }}</span>
                </template>
                <template v-slot:[`item.actions`]><v-icon small class="ui-cell-chevron">mdi-chevron-right</v-icon></template>
            </v-data-table>
        </ui-table-card>
        <p class="ui-small ui-muted mt-2">Só quem tem acesso total cria e altera perfis e dá acesso total a outro administrador. O perfil de cada administrador é escolhido em Administradores.</p>
    </div>
</template>

<script>
import axios from "axios";

// Lista dos perfis de acesso do backoffice (Administracao > Perfis).
export default {
    name: "ProfileList",

    data: () => ({
        profiles: [],
        loading: false,
        headers: [
            { text: "Perfil", value: "name" },
            { text: "Acesso", value: "access" },
            { text: "Administradores", value: "admins", width: 150 },
            { text: "", value: "actions", align: "end", width: 40 },
        ],
    }),

    created() {
        this.load();
    },

    methods: {
        async load() {
            this.loading = true;
            try {
                const result = await axios.get("/api/admin/profiles");
                this.profiles = result.data.content;
            } catch (error) {
                this.$dialog.notify.error(this.errorMessage(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.loading = false;
            }
        },

        // "4 áreas · 2 só leitura"
        summary(item) {
            const areas = Object.values(item.permissions || {});
            if (!areas.length) return "sem acesso a áreas";
            const readOnly = areas.filter((flags) => !flags.create && !flags.edit && !flags.delete).length;
            const text = `${areas.length} ${areas.length === 1 ? "área" : "áreas"}`;
            return readOnly ? `${text} · ${readOnly} só leitura` : text;
        },

        errorMessage(error) {
            const data = error && error.response && error.response.data;
            return (data && data.content && data.content.error && data.content.error.message) || "Não foi possível carregar os perfis.";
        },

        open(item) {
            this.$router.push(`/perfis/${item.id}`);
        },
    },
};
</script>
